module.exports = __webpack_public_path__ + "img/sleeve ruffle width.c56a0382.png";